// @flow
import React, { Component } from "react";
import moment from "moment";

import AccountGroupsTable from "./AccountGroupsTable";
import UserAvatar from "../../containers/profiles/UserAvatar";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";

type AccountInformationPropsType = {
  openProfileFrom: Function,
  user: { [key: string]: * }
};

class AccountInformation extends Component<AccountInformationPropsType, *> {

  render(): React$Element<*> {
    const user = this.props.user;
    return (
      <div className="app-panel">
        <div className="app-panel-content">
        
          <Grid container spacing={24}>
            <Grid item xs={12} md={3}>
              <UserAvatar user={user} />
            </Grid>
            <Grid item xs={12} md={9} style={{ overflowX: "auto" }}>
              <Table className="app-table no-border" style={{ maxWidth: "800px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell padding="dense" className="border">First Name</TableCell>
                    <TableCell padding="dense" className="normal editable" onClick={this.props.openProfileFrom}>
                      {user.firstName}
                    </TableCell>
                    <TableCell padding="dense" className="border">Last Name</TableCell>
                    <TableCell padding="dense" className="normal editable" onClick={this.props.openProfileFrom}>
                      {user.lastName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="dense" className="border">Company Name</TableCell>
                    <TableCell padding="dense" className="normal">
                      {user.company && user.company.name}
                    </TableCell>
                    <TableCell padding="dense" className="border">System Name</TableCell>
                    <TableCell padding="dense" className="normal editable" onClick={this.props.openProfileFrom}>
                      {user.defaultFacebase && user.defaultFacebase.name}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="dense" className="border">Email</TableCell>
                    <TableCell padding="dense" className="normal">{user.email}</TableCell>
                    <TableCell padding="dense" className="border">Created Date</TableCell>
                    <TableCell padding="dense" className="normal">{user.auditCreationDate ? moment.utc(user.auditCreationDate).local().format("DD/MMM/YYYY hh:mm A") : ""}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="dense" className="border">Last Logged in</TableCell>
                    <TableCell padding="dense" colSpan="3" className="normal">{user.lastLoggedIn ? moment.utc(user.lastLoggedIn).local().format("DD/MMM/YYYY hh:mm A") : ""}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </div>
        <AccountGroupsTable groups={user.groups} />
      </div>
    );
  }
}

export default AccountInformation;
